import { render, staticRenderFns } from "./AntsomiSyncStatus.vue?vue&type=template&id=893704c6&scoped=true"
import script from "./AntsomiSyncStatus.vue?vue&type=script&lang=js"
export * from "./AntsomiSyncStatus.vue?vue&type=script&lang=js"
import style0 from "./AntsomiSyncStatus.vue?vue&type=style&index=0&id=893704c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893704c6",
  null
  
)

export default component.exports